import defaultState from "./state";

const globalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "GLOBAL_ACTUALIZAR_DATOS_USUARIO": {
      const userData = { ...action.userData };
      return Object.assign({}, state, {
        userData,
      });
    }
    case "OPEN_CLOSE_TOAST": {
      const toast = { ...action.toast };
      return Object.assign({}, state, {
        toast,
      });
    }
    case "LOADING": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "SET_USER_PROFILE": {
      return Object.assign({}, state, {
        userProfile: action.profile,
      });
    }
    case "SET_COMPANY_LIST": {
      return Object.assign({}, state, {
        listaEmpresas: action.listaEmpresas,
      });
    }
    case "SET_REGIONES_LIST": {
      return Object.assign({}, state, {
        listaRegion: action.listaRegiones,
      });
    }

    case "SET_SELECTED_COMPANY": {
      return Object.assign({}, state, {
        companyId: action.companyId,
        companyName: action.companyName,
      });
    }
    case "SET_SUCURSALID": {
      return Object.assign({}, state, {
        sucursalId: action.sucursalId,
        sucursalName: action.sucursalName,
      });
    }
    case "OPEN_CLOSE_TOUR_CONFIRMATION": {
      return Object.assign({}, state, {
        tourConfirmationOpen: action.isOpen,
      });
    }
    case "SET_COLOR": {
      return Object.assign({}, state, {
        botomBorderColor: action.botomBorderColor,
      });
    }
    case "SET_USER_ACCESS_LIST": {
      let profiles = new Set();
      let roles = new Set();

      let rolesByCompany = {};
      let profilesByCompany = {};

      action.list.reduce((_, rol) => {
        let { ProfileCode, RolName, CompanyId } = rol;

        CompanyId = CompanyId?.toLowerCase();

        rolesByCompany[CompanyId] = rolesByCompany[CompanyId] ?? new Set([]);
        profilesByCompany[CompanyId] = profilesByCompany[CompanyId] ?? new Set([]);

        roles.add(RolName);
        profiles.add(ProfileCode);
        rolesByCompany[CompanyId].add(RolName);
        profilesByCompany[CompanyId].add(ProfileCode);
      });

      for(let rkey in rolesByCompany)
      {
        rolesByCompany[rkey] = [...rolesByCompany[rkey]];
        profilesByCompany[rkey] = [...profilesByCompany[rkey]];
      }

      profiles = [...profiles];
      roles = [...roles];

      return Object.assign({}, state, {
        userAccessList: action.list,
        userProfiles: profiles,
        myRoles: roles,
        myCompanyRoles: rolesByCompany,
        myCompanyProfiles: profilesByCompany
      });
    }
    case "SET_USER_FUNCTIONALITIES": {
      return Object.assign({}, state, {
        userAccessIds: action.ids,
      });
    }
    case "SET_PREVENT_NAVIGATION": {
      return Object.assign({}, state, {
        preventNavigation: action.preventNavigation,
      });
    }
    case "SET_ALL_LIST": {
      const list = { ...action.list };
      return Object.assign({}, state, {

        ListaComuna: list.ListaComuna,
        ListaTiposDenuncia: list.ListaTiposDenuncia,
        ListaTiposEmpresa: list.ListaTiposEmpresa,
        listaProfesiones: list.listaProfesiones,
        listaIsapres: list.listaIsapres,
        listaAfp: list.listaAfp,
        listaRegion: list.listaRegion,
        listaEstadoCivil: list.listaEstadoCivil,
        listaBancos: list.listaBancos,
        listaTipoJornada: list.listaTipoJornada,
        listaRubro: list.listaRubro,
        listaParentesco: list.listaParentesco,
        listadoSucursales: list.listadoSucursales,
        listaSexos: list.listaSexos,
        listaNacionalidades: list.listaNacionalidades,
        listaPueblosOriginarios: list.listaPueblosOriginarios,
        listaTiposCalle: list.listaTiposCalle,
        listaClasificacionesAccidentes: list.listaClasificacionesAccidentes,
        listaMediosPrueba: list.listaMediosPrueba,
        listaTiposCuenta: list.listaTiposCuenta,
        listaTiposContrato: list.listaTiposContrato,
        listaCategoriasOcupacionales: list.listaCategoriasOcupacionales,
        listaTiposIngreso: list.listaTiposIngreso,
        listaDirecciones: list.listaDirecciones,
        listaTipoDenuncias: list.listaTipoDenuncias,
        listaTipoEmpresa: list.listaTipoEmpresa,
        listaActividadEconomica: list.listaActividadEconomica,
        listaPropiedadEmpresa: list.listaPropiedadEmpresa,
        listaTiposAccidenteTrayecto: list.listaTiposAccidenteTrayecto,
        listaTiposAccidente: list.listaTiposAccidente,
      });
    }
    case "SET_SUCURSALES_LIST": {
      return Object.assign({}, state, {
        listadoSucursales: action.list,
      });
    }
    case "SET_SUCURSALES_OF_COMPANY": {
      return Object.assign({}, state, {
        companySucursales: action.list,
        sucursalId: "",
        sucursalName: null,
      });
    }
    case "RESET_GLOBAL_STATE": {
      return defaultState;
    }
    case "SET_EXPANDED": {
      return Object.assign({}, state, {
        isExpanded: action.expand,
      });
    }
    case "OPEN_CLOSE_TOUR": {
      return Object.assign({}, state, {
        isTourOpen: action.isOpen,
      });
    }
    case "SET_COMUNAS_BY_REGION_LIST": {
      return Object.assign({}, state, {
        listaComuna: action.comunas,
      });
    }
    default:
      return state;
  }
};

export default globalReducer;
